import Directive from './src/directive';
export default Directive;



// WEBPACK FOOTER //
// ./src/packages/loading/index.js